import { SettingsPage } from "@/components/dashboard/settings-page";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/buyer/settings/")({
	component: RouteComponent
});

function RouteComponent() {
	return <SettingsPage />;
}
